import { HTMLAttributes, ReactElement, ReactNode, useState } from 'react';
import { AccordionTitle } from './AccordionTitle';
import { joinClassNames } from '../../utils';
import styles from './styles.module.scss';
import { Icon } from '../Graphics/Icons/_deprecated/Icon';
import { IconName, IconVariant } from '../Graphics/Icons/_deprecated/enums';

const getTitle = (title: string | ReactElement) =>
  typeof title === 'string' ? <AccordionTitle titleText={title} /> : title;

export type AccordionProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  accordionTitle: string | ReactElement;
  initIsCollapsed?: boolean;
  onExpand?: () => void;
  onCollapse?: () => void;
};

export const Accordion = ({
  children,
  accordionTitle,
  initIsCollapsed = true,
  onExpand,
  onCollapse,
  className,
  ...props
}: AccordionProps) => {
  const [isCollapsed, setIsCollapsed] = useState(initIsCollapsed);

  const handleClick = () => {
    const newCollapsedState = !isCollapsed;
    setIsCollapsed(newCollapsedState);

    if (newCollapsedState === true) {
      if (onCollapse) onCollapse();
    } else if (onExpand) {
      onExpand();
    }
  };

  return (
    <section
      className={joinClassNames(styles.accordion, isCollapsed && styles.isCollapsed, className)}
      {...props}
    >
      <button type="button" className={styles.accordionToggle} onClick={handleClick}>
        <span className={styles.accordionToggleIcon}>
          <Icon name={IconName.ChevronDown} variant={IconVariant.AccordionToggleIcon} />
        </span>

        {getTitle(accordionTitle)}
      </button>

      <div className={styles.accordionContent}>{children}</div>
    </section>
  );
};

Accordion.displayName = 'Accordion';
